import styled from 'styled-components/macro';

export const ShipstationIcon = styled.img`
  margin: 0;
  width: 14px;
  height: 14px;

  cursor: pointer;
`;
